import { HttpClient } from '@wix/http-client';
import { getRandomTemplateImageBySectionAndFlow } from './fetchDataUtils';
import {
  TEXT_ON_IMAGE_FLOWS,
  TextOnImageGetPhotoSceneParams,
  TextOnImagePortraitPhotoParams,
  TextOnImageResponse,
} from '../types';
import {
  AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
  PromptHubAcceptedUrls,
} from '../../chatController/sgChat/constants';
import {
  PHOTO_SCENES_PROMPT_IDS,
  FLUX_PRO_DEPTH_PORTRAIT_IMAGE_GENERATION_PROMPT_ID,
} from './consts';
import { reportTextOnImageError } from './utils';
import { SG_FEATURE_NAME } from '../../consts';

const CONTROL_IMAGE_URL =
  'https://static.wixstatic.com/media/47a484_f408225ceb6144b982ec16f949b3490c~mv2.jpg';

export const getPortraitFlowImage = async (
  httpClient: HttpClient,
  sectionName: string,
  params: TextOnImageGetPhotoSceneParams,
): Promise<TextOnImageResponse | undefined> => {
  const { brightness, sectionId } = params;
  const photoScene = await getTextOnImagePhotoScenePortraitFlow(httpClient, {
    ...params,
    brightness,
  });

  if (!photoScene) return;

  const templateImageFromCMS = await getRandomTemplateImageBySectionAndFlow(
    sectionName,
    TEXT_ON_IMAGE_FLOWS.PORTRAIT,
    sectionId,
  );

  const controlImageUrl = templateImageFromCMS?.url || CONTROL_IMAGE_URL;
  const imageUrl = await getTextOnImagePortraitPhotoPromptHub(httpClient, {
    portrait_item1: photoScene,
    controlImage: controlImageUrl,
    brightness,
  });

  return { imageUrl, photoScene, controlImageUrl };
};

export const getTextOnImagePhotoScenePortraitFlow = async (
  httpClient: HttpClient,
  params: TextOnImageGetPhotoSceneParams,
): Promise<string> => {
  try {
    const { data } = await httpClient.post(
      PromptHubAcceptedUrls.AI_GATEWAY_URL,
      {
        appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
        promptId: PHOTO_SCENES_PROMPT_IDS[TEXT_ON_IMAGE_FLOWS.PORTRAIT],
        params,
        userRequestInfo: {
          featureName: SG_FEATURE_NAME,
        },
      },
    );
    const { portrait_item1 } = JSON.parse(data.response.generatedTexts[0]);
    return portrait_item1;
  } catch (error: any) {
    const errorResponse = error.response?.data;
    reportTextOnImageError(
      `Failed to get text on image photo scene: ${errorResponse}`,
    );
    return 'A stylish young woman model in her late 20s with a sleek bob haircut and radiant skin, wearing an elegant sky blue designer blouse with soft pleats and tailored details, captured against a vibrant grass green background.';
  }
};

export const getTextOnImagePortraitPhotoPromptHub = async (
  httpClient: HttpClient,
  params: TextOnImagePortraitPhotoParams,
): Promise<string | undefined> => {
  try {
    const { data } = await httpClient.post(
      PromptHubAcceptedUrls.AI_GATEWAY_GET_REPLICATE_AI_IMAGE,
      {
        appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
        promptIdToFetch: FLUX_PRO_DEPTH_PORTRAIT_IMAGE_GENERATION_PROMPT_ID,
        params,
      },
    );

    return data?.response?.url;
  } catch (error: any) {
    const errorResponse = error.response?.data;
    reportTextOnImageError(
      `Failed to get portrait flow image: ${errorResponse}`,
    );
  }
};
